import { render, staticRenderFns } from "./SpecialReportsWrapper.vue?vue&type=template&id=c450cc80&"
import script from "./SpecialReportsWrapper.vue?vue&type=script&lang=js&"
export * from "./SpecialReportsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports